import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { replaceWithQuery as replace, pushWithQuery as push } from 'utils/routing';

import * as baseActions from 'actions/base';
import * as driverActions from 'actions/drivers';
import * as userActions from 'actions/users';
import * as vehicleActions from 'actions/vehicles';
import * as dedicatedContractActions from 'actions/dedicated-contracts';

import { vehiclesIncreasingBySize } from 'utils/sort';

import { getCurrentCarrier } from 'redux/modules/carrier-section/selectors';

import { getAllRoutePairs } from 'reselects';

import { updateCarrier } from 'actions/carriers';
import { carrierUpdated as carrierUpdatedAction } from 'redux/modules/carrier-section/effects';

import CarrierVehicleEditModal from 'components/CarrierVehicleEditModal';
import { isPreferencePresent, ALLOW_STATE_UPDATE } from 'modules/preferences-manager/preferences';
import { VEHICLE_STATES } from 'components/CarrierDetails/Constants';

const actionCreators = {
  ...driverActions,
  ...userActions,
  ...baseActions,
  ...vehicleActions,
  ...dedicatedContractActions,
  updateCarrier,
  push,
  replace,
  carrierUpdated: carrierUpdatedAction,
};

class CarrierDetailsContainer extends Component {
  render() {
    const {
      carrier,
      createVehicle,
      updateVehicle,
      removeVehicle,
      onCloseModal,
      match,
      availableVehiclesTypes,
      allowStateUpdate,
      carrierUpdated,
      isAddVehicleLite,
    } = this.props;

    if (!carrier) {
      return null;
    }

    const vehicles = carrier.vehicles.sort(vehiclesIncreasingBySize).filter((v) => !!v);
    const selectedVehicle = parseInt(match.params.vehicle_id, 10);
    const currentVehicle = vehicles.filter((vehicle) => vehicle.id === selectedVehicle)[0];

    return carrier ? (
      <CarrierVehicleEditModal
        isAddVehicleLite={isAddVehicleLite}
        onClose={onCloseModal}
        availableVehiclesTypes={availableVehiclesTypes}
        allowStateUpdate={allowStateUpdate}
        vehicle={currentVehicle}
        carrier={carrier}
        onSave={async (vehicle) => {
          if (vehicle.id) {
            await updateVehicle({ ...vehicle, carrier: vehicle.carrier.url });
          } else {
            await createVehicle({ ...vehicle, carrier: carrier.url });
          }
        }}
        onSaveSuccesfully={onCloseModal}
        remove={async (oldVehicle) => {
          const newVehicle = await removeVehicle({
            ...oldVehicle,
          });
          onCloseModal();
          if (newVehicle.status === VEHICLE_STATES.removed) {
            carrierUpdated(carrier.id);
          }
        }}
      />
    ) : null;
  }
}

CarrierDetailsContainer.propTypes = {
  createVehicle: PropTypes.func,
  updateVehicle: PropTypes.func,
  removeVehicle: PropTypes.func,
  carrier: PropTypes.object,
  onCloseModal: PropTypes.func,
  match: PropTypes.object,
  availableVehiclesTypes: PropTypes.object,
  carrierUpdated: PropTypes.func,
  allowStateUpdate: PropTypes.bool,
};

export default connect((state, { match }) => {
  const availableVehiclesTypes = state.me.country_settings.available_vehicle_types;
  const allowStateUpdate = isPreferencePresent(state.me, ALLOW_STATE_UPDATE);

  return {
    allowStateUpdate,
    availableVehiclesTypes: availableVehiclesTypes,
    carrier: getCurrentCarrier(state),
    allRoutes: getAllRoutePairs(state),
    dedicatedContracts: state.dedicatedContracts.results || [],
  };
}, actionCreators)(CarrierDetailsContainer);
